export enum DiferencialCotacao {
  OFERTA = "OFERTA",
  ASSISTENCIA = "ASSISTENCIA",
  VIDROS = "VIDROS",
}
